import React from 'react'
import {Nullable} from '../../../../app/TypeHelpers'
import {CLEANING_TIME} from '../../../../CodeMaster'
import equal from 'fast-deep-equal'

export interface ReservationTimeSettingCleaningProps {
    cleaningTimeBeforeReservation: Nullable<CLEANING_TIME>
    cleaningTimeAfterReservation: Nullable<CLEANING_TIME>
}
const ReservationTimeSettingCleaning: React.FC<ReservationTimeSettingCleaningProps> = React.memo(props => {
    const beforeText =
        props.cleaningTimeBeforeReservation
            ? `予約前 ${props.cleaningTimeBeforeReservation.label}分`
            : ''
    const afterText =
        props.cleaningTimeAfterReservation
            ? `予約後 ${props.cleaningTimeAfterReservation.label}分`
            : ''

    if (beforeText === '' && afterText === '') {
        return <div>予定がありません</div>
    }
    return <>
        {beforeText && <div>{beforeText}</div>}
        {afterText && <div>{afterText}</div>}
    </>
}, (prevProps, nextProps) => (prevProps === nextProps || equal(prevProps, nextProps)))

ReservationTimeSettingCleaning.displayName = 'ReservationTimeSettingCleaning'
export default ReservationTimeSettingCleaning
